import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Chip, type ChipProps, Tooltip, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { taskTableStyles } from '../taskUi.tsx';

type TTaskStatusChipWithTooltipProps = {
  label: ReactNode;
  color?: ChipProps['color'];
  description?: ReactNode;
  chipSx?: ChipProps['sx'];
};

export const TaskStatusChipWithTooltip = ({
  label,
  color = 'default',
  description,
  chipSx,
}: TTaskStatusChipWithTooltipProps) => (
  <Box component="span" sx={taskTableStyles.statusWithInfo}>
    <Chip
      size="small"
      label={
        <Box component="span" sx={taskTableStyles.statusLabel}>
          {label}
        </Box>
      }
      color={color}
      variant="filled"
      sx={[taskTableStyles.statusChip, chipSx] as SxProps<Theme>}
    />
    {description && (
      <Tooltip
        title={description}
        placement="bottom-start"
        slotProps={{
          tooltip: { sx: taskTableStyles.statusTooltip },
        }}
      >
        <Box
          component="span"
          tabIndex={0}
          role="button"
          aria-label={`РћРїРёСЃ СЃС‚Р°С‚СѓСЃСѓ "${String(label)}"`}
          sx={taskTableStyles.statusInfo}
        >
          <InfoOutlinedIcon fontSize="small" />
        </Box>
      </Tooltip>
    )}
  </Box>
);
